<table
  class="table tax"
  #tableResponsive
  [style.display]="(isHandheld$ | async) ? 'none' : ''"
>
  <thead class="table__thead">
    <tr class="table__tr">
      <th class="table__th">
        {{ "products.us-tax-record-date" | translate }}
        <eds-footnote
          [attr.data-placement]="'US Tax:UsTaxRecordDate'"
          placement="US Tax:UsTaxRecordDate"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-record-date']"
          edsTooltip
          [attr.data-tooltip-content]="tooltips['products.us-tax-record-date']"
          tooltipTheme="dark"
          [analyticsName]="'products.us-tax-record-date' | translate"
          [tooltipContent]="tooltips['products.us-tax-record-date']"
          [tooltipAriaLabel]="'products.us-tax-record-date' | translate"
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>

      <th class="table__th">
        {{ "products.us-tax-ordinary-dividends" | translate }}
        <eds-footnote
          [attr.data-placement]="'US Tax:UsTaxOrdinaryDividends'"
          placement="US Tax:UsTaxOrdinaryDividends"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-ordinary-dividends']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.us-tax-ordinary-dividends']
          "
          [analyticsName]="'products.us-tax-ordinary-dividends' | translate"
          tooltipTheme="dark"
          [tooltipContent]="tooltips['products.us-tax-ordinary-dividends']"
          [tooltipAriaLabel]="'products.us-tax-ordinary-dividends' | translate"
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th">
        {{ "products.us-tax-qualified-dividends" | translate }}
        <eds-footnote
          placement="US Tax:UsTaxQualifiedDividends"
          [attr.data-placement]="'US Tax:UsTaxQualifiedDividends'"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-qualified-dividends']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.us-tax-qualified-dividends']
          "
          [analyticsName]="'products.us-tax-qualified-dividends' | translate"
          tooltipTheme="dark"
          [tooltipContent]="tooltips['products.us-tax-qualified-dividends']"
          [tooltipAriaLabel]="'products.us-tax-qualified-dividends' | translate"
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th">
        {{ "products.us-tax-cap-gain-distributions" | translate }}
        <eds-footnote
          placement="US Tax:UsTaxCapGainsDistributions"
          [attr.data-placement]="'US Tax:UsTaxCapGainsDistributions'"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-cap-gain-distributions']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.us-tax-cap-gain-distributions']
          "
          tooltipTheme="dark"
          [tooltipContent]="tooltips['products.us-tax-cap-gain-distributions']"
          [analyticsName]="'products.us-tax-cap-gain-distributions' | translate"
          [tooltipAriaLabel]="
            'products.us-tax-cap-gain-distributions' | translate
          "
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th">
        {{ "products.us-tax-unrecaptured-section-1250-gain" | translate }}
        <eds-footnote
          placement="US Tax:UsTaxUnrecapturedSection1250Gain"
          [attr.data-placement]="'US Tax:UsTaxUnrecapturedSection1250Gain'"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-unrecaptured-section-1250-gain']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.us-tax-unrecaptured-section-1250-gain']
          "
          tooltipTheme="dark"
          [tooltipContent]="
            tooltips['products.us-tax-unrecaptured-section-1250-gain']
          "
          [analyticsName]="
            'products.us-tax-unrecaptured-section-1250-gain' | translate
          "
          [tooltipAriaLabel]="
            'products.us-tax-unrecaptured-section-1250-gain' | translate
          "
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th">
        {{ "products.us-tax-nontaxable-return-of-capital" | translate }}
        <eds-footnote
          placement="US Tax:UsTaxNonTaxableReturnOfCapital"
          [attr.data-placement]="'US Tax:UsTaxNonTaxableReturnOfCapital'"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-nontaxable-return-of-capital']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.us-tax-nontaxable-return-of-capital']
          "
          tooltipTheme="dark"
          [tooltipContent]="
            tooltips['products.us-tax-nontaxable-return-of-capital']
          "
          [analyticsName]="
            'products.us-tax-nontaxable-return-of-capital' | translate
          "
          [tooltipAriaLabel]="
            'products.us-tax-nontaxable-return-of-capital' | translate
          "
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th">
        {{ "products.us-tax-section-199a-dividends" | translate }}
        <eds-footnote
          placement="US Tax:UsTaxSection199aDividends"
          [attr.data-placement]="'US Tax:UsTaxSection199aDividends'"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-section-199a-dividends']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.us-tax-section-199a-dividends']
          "
          tooltipTheme="dark"
          [tooltipContent]="tooltips['products.us-tax-section-199a-dividends']"
          [analyticsName]="'products.us-tax-section-199a-dividends' | translate"
          [tooltipAriaLabel]="
            'products.us-tax-section-199a-dividends' | translate
          "
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th">
        {{ "products.us-tax-foreign-tax-paid" | translate }}
        <eds-footnote
          placement="US Tax:UsTaxForeignTaxPaid"
          [attr.data-placement]="'US Tax:UsTaxForeignTaxPaid'"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-foreign-tax-paid']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.us-tax-foreign-tax-paid']
          "
          tooltipTheme="dark"
          [tooltipContent]="tooltips['products.us-tax-foreign-tax-paid']"
          [analyticsName]="'products.us-tax-foreign-tax-paid' | translate"
          [tooltipAriaLabel]="'products.us-tax-foreign-tax-paid' | translate"
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th">
        {{ "products.us-tax-exempt-interest-dividends" | translate }}
        <eds-footnote
          placement="US Tax:UsTaxExemptInterestDividends"
          [attr.data-placement]="'US Tax:UsTaxExemptInterestDividends'"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.us-tax-exempt-interest-dividends']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.us-tax-exempt-interest-dividends']
          "
          tooltipTheme="dark"
          [tooltipContent]="
            tooltips['products.us-tax-exempt-interest-dividends']
          "
          [analyticsName]="
            'products.us-tax-exempt-interest-dividends' | translate
          "
          [tooltipAriaLabel]="
            'products.us-tax-exempt-interest-dividends' | translate
          "
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
      <th class="table__th">
        {{ "products.interest-on-tax-reclaim-refunds" | translate }}
        <eds-footnote
          theme="dark"
          placement="USInterestOnTaxReclaimRefunds"
          [attr.data-placement]="'USInterestOnTaxReclaimRefunds'"
        ></eds-footnote>
        <button
          class="print-hidden"
          *ngIf="tooltips['products.interest-on-tax-reclaim-refunds']"
          edsTooltip
          [attr.data-tooltip-content]="
            tooltips['products.interest-on-tax-reclaim-refunds']
          "
          tooltipTheme="dark"
          [tooltipContent]="
            tooltips['products.interest-on-tax-reclaim-refunds']
          "
          [analyticsName]="
            'products.interest-on-tax-reclaim-refunds' | translate
          "
          [tooltipAriaLabel]="
            'products.interest-on-tax-reclaim-refunds' | translate
          "
          [tooltipButton]="true"
        >
          <eds-icon type="info" size="small"></eds-icon>
        </button>
      </th>
    </tr>
  </thead>

  <tbody class="table__body">
    <ng-container *ngFor="let distribution of distributions">
      <tr class="table__tr">
        <td class="table__td">
          {{
            distribution.recordType === "Detail"
              ? distribution.recordDate
              : ("products.us-tax-total" | translate)
          }}
        </td>
        <td class="table__td">{{ distribution.ordinaryDividends }}</td>
        <td class="table__td">{{ distribution.qualifiedDividends }}</td>
        <td class="table__td">{{ distribution.capGainDistributions }}</td>
        <td class="table__td">
          {{ distribution.unrecapturedSection1250Gain }}
        </td>
        <td class="table__td">{{ distribution.nonTaxableReturnOfCapital }}</td>
        <td class="table__td">{{ distribution.section199aDividends }}</td>
        <td class="table__td">{{ distribution.foriegnTaxPaid }}</td>
        <td class="table__td">{{ distribution.exemptInterestDividends }}</td>
        <td class="table__td">{{ distribution.interestTaxReclaimRefund }}</td>
      </tr>
    </ng-container>
  </tbody>
</table>
<ng-container *ngFor="let card of cards">
  <ng-container *ngIf="isHandheld$ | async">
    <eds-panel
      edsSpacing="sm"
      [hasBorders]="true"
      [hasBorderRadius]="false"
      [hasPadding]="true"
    >
      <eds-info-item *ngFor="let item of card" [info]="item" edsSpacing="sm">
      </eds-info-item>
    </eds-panel>
  </ng-container>
</ng-container>
<eds-proximal placement="UsTaxDistributionsBottom"></eds-proximal>
